<form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flex-wrap -mx-2">
  <ng-container *ngFor="let control of config">
    <div [class]="getWidthClass(control.width)" class="px-2 mt-2 items-center">
      <div class="form-control {{control.style}}">
        <ng-container *ngTemplateOutlet="controlTemplate; context: {$implicit: control}"></ng-container>
      </div>
    </div>
  </ng-container>

  <ng-template #controlTemplate let-control>
    <label [attr.for]="control.name" class="block text-sm font-medium text-gray-700 dark:text-gray-400"
      [ngClass]="{'hidden': control.type === 'checkbox' || control.type === 'json-builder' || control.type === 'toggle' || control.hideHeadLabel}">
      {{ control.label }}
    </label>
    <input *ngIf="control.type === 'input'" [type]="control.type" [formControlName]="control.name"
      [placeholder]="control.placeholder" [disabled]="control.disabled"
      class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-header focus:border-header sm:text-sm dark:border-0 dark:bg-dark-background-alt dark:text-gray-200 {{control.disabled ? 'bg-gray-100' : ''}}" />
    <textarea *ngIf="control.type === 'textarea'" [formControlName]="control.name" [placeholder]="control.placeholder"
      [disabled]="control.disabled" [rows]="control.rows || 4"
      class="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-header focus:border-header sm:text-sm dark:border-0 dark:bg-dark-background-alt dark:text-gray-200 resize-none {{control.disabled ? 'bg-gray-100' : ''}}"
      style="min-height: 100px; box-sizing: border-box;"></textarea>
    <select *ngIf="control.type === 'select'" [formControlName]="control.name"
      class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-header focus:border-header sm:text-sm dark:border-0 dark:bg-dark-background-alt dark:text-gray-200">
      <option *ngFor="let option of control.options" [value]="option.value">
        {{ option.label }}
      </option>
    </select>
    <app-icons-dropdown *ngIf="control.type === 'icon-select'" [formControlName]="control.name"></app-icons-dropdown>
    <div *ngIf="control.type === 'checkbox'" class="mt-1 flex items-start">
      <div class="flex items-center h-5">
        <input [id]="control.name" type="checkbox" [formControlName]="control.name"
          class="custom-checkbox focus:ring-header h-4 w-4 text-header border-gray-300 rounded" />
      </div>
      <div class="ml-3 text-sm custom-checkbox-container">
        <label [for]="control.name" class="font-medium text-gray-700 dark:text-gray-400">
          {{ control.label }}
        </label>
        <p *ngIf="control.sublabel" class="text-gray-500 dark:text-gray-400">
          {{ control.sublabel }}
        </p>
      </div>
    </div>
    <div *ngIf="control.type === 'color-picker'" class="relative flex items-start flex-row">
      <input id="{{control.name}}-color-picker" type="color" (input)="onColorPickerChange($event, control.name)"
        [value]="form.get(control.name)?.value || '#ffffff'" (paste)="onTextInputChange($event, control.name)"
        (change)="onTextInputChange($event, control.name)"
        class="absolute left-1 top-3 w-6 h-6 opacity-0 cursor-pointer">
      <input [id]="control.name" type="text" [formControlName]="control.name"
        class="mt-1 block uppercase w-full pl-10 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-header bg-white focus:border-header sm:text-sm dark:border-0 dark:bg-dark-background-alt dark:text-gray-200">
    </div>
    <span
      *ngIf="form.controls[control.name].errors && form.controls[control.name].touched && control.type !== 'icon-select'"
      class="text-red-500 text-xs">
      Error in {{ control.label }}
    </span>
    <span *ngIf="form.controls[control.name].errors?.['hexColor'] && control.type === 'color-picker'"
      class="text-red-500 text-xs">
      Invalid color format
    </span>


    <app-multi-select *ngIf="control.type === 'multi-select'" [options]="control.options" [label]="'Roles'"
      [selectedValues]="control?.selectedValues || []" [commaDelimited]="true" [class]="control?.boxClass"
      [labelKey]="'label'" [valueKey]="'value'" [disabledSorting]="true" [disabledSearchBox]="true" badgePosition="left"
      (onSelect)="onMultiSelectChange($event, control.name)">
    </app-multi-select>


    <app-multi-select-chip *ngIf="control.type === 'multi-select-chip'" [options]="control.options"
      [label]="control.label" [formControlName]="control.name"
      (selectedValuesChange)="onMultiSelectChipChange($event, control.name)">
    </app-multi-select-chip>

    <div *ngIf="control.type === 'json-text'">
      <app-json-editor [formControlName]="control.name" [placeholder]="control.placeholder"></app-json-editor>
    </div>

    <div *ngIf="control.type === 'json-builder'">
      <app-json-builder [formControlName]="control.name" [label]="control.label"
        (ngModelChange)="onJsonBuilderChange($event, control.name)"></app-json-builder>
    </div>

    <div *ngIf="control.type === 'toggle'"
      class="mt-1 flex items-center bg-white rounded-md p-4 border border-gray-200 shadow-sm">
      <label class="relative inline-flex items-center cursor-pointer select-none">
        <input type="checkbox" [formControlName]="control.name" class="sr-only peer">
        <div
          class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-header rounded-full peer dark:bg-gray-700 peer-checked:bg-header transition-colors">
        </div>
        <div
          class="absolute left-0.5 top-0.5 w-5 h-5 bg-white border border-gray-300 rounded-full transition-transform peer-checked:translate-x-full">
        </div>
      </label>
      <span class="ml-3 text-sm font-medium text-gray-700 dark:text-gray-400">{{ form.get(control.name)?.value ? control.toggleText : (control.toggleTextOff || control.toggleText) }}</span>
    </div>

  </ng-template>
</form>
